import objectFitVideos from 'object-fit-videos';

const io = new IntersectionObserver(onIntersection, {
  rootMargin: '50px 0px',
  threshold: 0.01
});

function onIntersection(entries) {
  entries.forEach(entry => {
    if (!entry.intersectionRatio) {
      return;
    }

    if ('onIntersection' in entry.target) {
      entry.target.onIntersection();
    }
  });
}

class MelVideo extends HTMLElement {
  constructor(self) {
    self = super(self);
    this._video = this.querySelector('video');
    return self;
  }

  static get is() {
    return 'mel-video';
  }

  get source() {
    return this._video.getAttribute('data-src') ? this._video.getAttribute('data-src') : '';
  }

  set source(path) {
    this._video.setAttribute('src', path);
  }

  get fit() {
    return this.hasAttribute('fit');
  }

  connectedCallback() {
    if (!this.querySelector('video')) return;

    this._bindHandlers();

    if (this.fit) this._applyObjectFit();

    // Add to observer
    io.observe(this);
  }

  disconnectedCallback() {
    io.unobserve(this);
  }

  onIntersection() {
    this._loadVideo();
    io.unobserve(this);
  }

  _loadVideo() {
    this.source = this.source;
  }

  _applyObjectFit(video) {
    this._video.style.objectFit = 'cover';
    this._video.style.objectPosition = this.position;
    this._video.style.fontFamily = `
      object-fit: cover; 
      object-position: ${this.position}`;
    this._video.style.height = '100%';
    this._video.style.width = '100%';
    this._video.style.display = 'block';

    objectFitVideos(video);
  }

  _bindHandlers() {
    this._loadVideo = this._loadVideo.bind(this);
  }
}

customElements.define(MelVideo.is, MelVideo);
